let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kPcg1")).then(() => parcelRequire('bkt7o'));